import { useEffect, useState } from "react";
import { useGlobalReducer } from "../../../GlobalContext";
import { GetDataImportAvailableColumns } from "../../api/dataImportService";
import { Loading } from "../../elements/Loading";
import { badgeClassName } from "../../elements/badgeClassName";

interface AvailableColumn {
  Name: string;
  FriendlyName: string;
  DataType?: string;
  MaxLength?: number;
  MinValue?: number | null;
  MaxValue?: number | null;
  AllowedValues?: string;
  IsCustom?: boolean;
}

function constraintsText(column: AvailableColumn) {
  return [
    column.MaxLength ? `Max length: ${column.MaxLength}` : "",
    column.MinValue !== null && column.MinValue !== undefined
      ? `Min: ${column.MinValue}`
      : "",
    column.MaxValue !== null && column.MaxValue !== undefined
      ? `Max: ${column.MaxValue}`
      : "",
    column.AllowedValues ? `Allowed values: ${column.AllowedValues}` : "",
  ]
    .filter(Boolean)
    .join("; ");
}

/** The columns an import file can have, with their types and limits. */
export function DataImportAvailableColumns() {
  const globalDispatch = useGlobalReducer();
  const [columns, setColumns] = useState<AvailableColumn[]>();

  useEffect(() => {
    let cancelled = false;

    GetDataImportAvailableColumns(globalDispatch).then(
      (response: { data?: unknown }) => {
        if (!cancelled) {
          setColumns(Array.isArray(response?.data) ? response.data : []);
        }
      }
    );

    return () => {
      cancelled = true;
    };
  }, [globalDispatch]);

  if (!columns) {
    return <Loading />;
  }

  return (
    <>
      <div className="alert alert-info">
        Use the value in the Column Name column as the header when preparing
        your CSV import file.
      </div>
      <div className="table-responsive">
        <table className="table table-hover">
          <thead>
            <tr>
              <th scope="col">Column Name</th>
              <th scope="col">Display Name</th>
              <th scope="col">Data Type</th>
              <th scope="col">Constraints</th>
              <th scope="col">Custom</th>
            </tr>
          </thead>
          <tbody>
            {columns.map((column) => (
              <tr key={column.Name}>
                <td>{column.Name}</td>
                <td>{column.FriendlyName}</td>
                <td>{column.DataType ?? ""}</td>
                <td>{constraintsText(column)}</td>
                <td>
                  <span
                    className={badgeClassName(column.IsCustom ? "success" : "info")}
                  >
                    {column.IsCustom ? "Yes" : "No"}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default DataImportAvailableColumns;
